interface PageHeroProps {
  eyebrow: string;
  title: string;
  titleItalic?: string;
  description: string;
}

export default function PageHero({ eyebrow, title, titleItalic, description }: PageHeroProps) {
  return (
    <section className="pt-8 pb-8 lg:pt-10 lg:pb-10 border-b border-border">
      <div className="mx-auto max-w-container px-6 lg:px-10">
        <div className="max-w-5xl">
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-3">
            {eyebrow}
          </div>
          <h1 className="font-serif text-[40px] sm:text-[52px] lg:text-[64px] leading-[1.03] tracking-tight">
            {title}
            {titleItalic && <> <span className="italic text-muted-foreground">{titleItalic}</span></>}
          </h1>
          <p className="mt-3 text-lg lg:text-xl text-muted-foreground leading-relaxed max-w-2xl">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
}
